import { Timestamp } from "@angular/fire/firestore";
import { Competition } from "./competition";

export class Dome {
    id: string;
    name: string;
    description: string;
    geo:{
        longitude?: number;
        latitude?: number;
    }
    published: boolean;
    attachments: any[];
    triggers: any[];
    selectedType: string;
    selectedModelId: number;
    selectedOrientation: string;
    selectedVoiceId: string;
    selectedMapId: string;
    selectedTrainLine: any;
    stations: string;
    url: string;
    dateCreated: Timestamp;
    dateUpdated: Timestamp;
    createdBy: any;
    storyFileName: string;
    phone: string;
    story: string;
    features: any;
    competitionId: string;
    languages: any[];
    qrConfig: QrConfig;
}

export class QrConfig {
    constructor() {
        this.qrPosition = {x: 128, y: 128};
        this.qrSize = {x: 256, y: 256};
        this.qrPrompt = '';
        this.genImgWid = 512;
        this.posterText = '';
        this.textColour = "black";
        this.textSize = 16;
        this.textX = 0;
        this.textY = 0;
        this.textAlignVertical = 'top';
        this.textAlignHorizontal = 'left';
    }
    qrPosition: any;
    qrSize: any;
    qrImage: any;
    qrStyle: string;
    qrPrompt: string;
    genImgWid: number;
    posterText: string;
    textColour: string = "black";
    textSize: number = 16;
    textX: number = 0;
    textY: number = 0;
    textAlignVertical: string = 'top';
    textAlignHorizontal: string = 'left';
}

export class Attachment{
    constructor()
    {
        this.name = '';
        this.url = '';
        this.size = 0;
        this.type = '';
        this.format = '';
    }
    name: string;
    url: string;
    size: number;
    type: string;
    format: string;
    info: Info;
    directUrl : string;
}

export class Trigger{
    constructor()
    {
        this.name = '';
        this.url = '';
        this.size = 0;
        this.type = '';
        this.format = '';
    }
    name: string;
    url: string;
    size: number;
    type: string;
    format: string;
    info: Info;
}

export class Info {
    description:string;
    title:string;
}